import React from 'react';

import { Children } from '../types';
import style from './index.module.css';

type Props = {
    book?: boolean;
    bold?: boolean;
    small?: boolean;
    xsmall?: boolean;
} & Children;

export const Caption = ({ book, bold, small, xsmall, children }: Props) => (
    <span
        className={`${style.caption} ${book ? style.book : ''} ${bold ? style.bold : ''} ${small ? style.small : ''} ${
            xsmall ? style.xsmall : ''
        }`}
    >
        {children}
    </span>
);
